import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';

@Component({
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.css']
})
export class InviteComponent extends BaseComponent implements OnInit {

  constructor(
    private router: Router
  ) { 
    super();
    this._pageTitle = '';
  }

  ngOnInit(): void {
  }

  inviteFirm() {
    this.router.navigate(['invite/company'])
  }

  inviteFriends() {
    this.router.navigate(['invite/user'])
  }

}
